import { routes } from "consts";
import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { removeTrailingSlash } from "utils/urlUtils";

interface Dot {
  name: string;
  path: string;
  isEdit: boolean;
}

const getDots = (isAddPage: boolean) => {
  const sharedDots = [
    { name: "Dla kursanta", path: routes.COURSES_EDIT_PREVIEW, isEdit: true },
    { name: "Zjazdy", path: routes.COURSES_EDIT_SESSION, isEdit: true },
    { name: "Egzaminy", path: routes.COURSES_EDIT_EXAMS, isEdit: true },
    { name: "Harmonogram", path: routes.COURSES_EDIT_SCHEDULE, isEdit: true },
    { name: "Płatności", path: routes.COURSES_EDIT_PAYMENTS, isEdit: true },
    { name: "Polityka cen", path: routes.COURSES_EDIT_PAYMENTS_POLICY, isEdit: true },
    { name: "Formularz", path: routes.COURSES_EDIT_FORM, isEdit: true },
    { name: "Ankiety", path: routes.COURSES_EDIT_SURVEYS, isEdit: true },
  ];
  const firstDot = isAddPage
    ? { name: "Podstawowe", path: routes.COURSES_ADD, isEdit: false }
    : { name: "Podstawowe", path: routes.COURSES_EDIT_INFO, isEdit: true };

  sharedDots.unshift(firstDot);
  return sharedDots;
};

export const CourseConfigurationTabs = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const { courseId } = useParams();
  const isAddPage = removeTrailingSlash(location.pathname) === removeTrailingSlash(routes.COURSES_ADD);
  const dots = getDots(isAddPage);

  const activeDotClasses = {
    true: "block pb-3 text-primary-500 whitespace-nowrap border-b-2 border-primary-500",
    false:
      "block pb-3 text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 whitespace-nowrap",
  };

  const resolveClassNames = (dot: Dot) => {
    const pointerClass = !shouldStayOnThePage(dot) ? "cursor-pointer" : "";
    const matchingPath = removeTrailingSlash(dot.isEdit ? `${routes.COURSES_EDIT(courseId)}/${dot.path}` : dot.path);
    const isActiveStage = removeTrailingSlash(location.pathname).startsWith(matchingPath);

    return `${pointerClass} ${activeDotClasses[`${isActiveStage}`]}`;
  };

  const onClickHandler = (dot: Dot) => {
    if (shouldStayOnThePage(dot)) return;
    navigate(dot.path);
  };

  const shouldStayOnThePage = (dot: Dot) => (isAddPage && dot.isEdit) || (!isAddPage && !dot.isEdit);

  return (
    <div className="mt-2 w-full">
      <div className="relative flex justify-center">
        <ul className="no-scrollbar relative -mx-4 flex flex-nowrap overflow-x-scroll text-sm font-medium sm:-mx-6 lg:-mx-8">
          {dots.map((x) => (
            <li
              key={x.name}
              className="mr-6 first:pl-4 last:mr-0 last:pr-4 sm:first:pl-6 sm:last:pr-6 lg:first:pl-8 lg:last:pr-8"
              onClick={() => onClickHandler(x)}
            >
              <span className={resolveClassNames(x)}>{x.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
